// Extracted from the buy-box custom liquid (scripts/pdp-polish-2026-10-11.js). Liquid values: window.USCT_PDP.
function updateQty(change) {
  var input = document.getElementById('quantity');
  var val = parseInt(input.value) || 1;
  val = Math.max(1, val + change);
  input.value = val;
}

function getThumbs() { return document.querySelectorAll('.thumbnail'); }

function getActiveThumbIndex() {
  var thumbs = getThumbs();
  for (var i = 0; i < thumbs.length; i++) {
    if (thumbs[i].classList.contains('active')) return i;
  }
  return 0;
}

function updateImageCounter() {
  var counter = document.getElementById('imageCounter');
  var thumbs = getThumbs();
  if (counter && thumbs.length > 1) {
    counter.textContent = (getActiveThumbIndex() + 1) + '/' + thumbs.length;
  }
}

function changeImage(src, thumb) {
  var _mi = document.getElementById('mainImage'); _mi.removeAttribute('srcset'); _mi.src = src;
  getThumbs().forEach(function(t) { t.classList.remove('active'); });
  thumb.classList.add('active');
  updateImageCounter();
}

function syncLightboxToActive() {
  var mainImage = document.getElementById('mainImage');
  var lightboxImage = document.getElementById('lightboxImage');
  var counter = document.getElementById('lightboxCounter');
  var thumbs = getThumbs();
  lightboxImage.src = mainImage.src;
  lightboxImage.style.transform = '';
  lightboxImage.style.cursor = 'zoom-in';
  if (counter) {
    counter.textContent = thumbs.length > 1 ? (getActiveThumbIndex() + 1) + ' / ' + thumbs.length : '';
  }
  var prev = document.getElementById('lightboxPrev');
  var next = document.getElementById('lightboxNext');
  if (prev && next) {
    if (thumbs.length > 1) { prev.classList.add('visible'); next.classList.add('visible'); }
    else { prev.classList.remove('visible'); next.classList.remove('visible'); }
  }
}

function openZoom() {
  var lightbox = document.getElementById('imageLightbox');
  syncLightboxToActive();
  lightbox.classList.add('active');
  document.body.style.overflow = 'hidden';
}

function closeLightbox() {
  var lightbox = document.getElementById('imageLightbox');
  lightbox.classList.remove('active');
  document.body.style.overflow = '';
}

function lightboxStep(direction) {
  var thumbs = getThumbs();
  if (thumbs.length < 2) return;
  var idx = getActiveThumbIndex();
  var nextIdx = idx + direction;
  if (nextIdx < 0) nextIdx = thumbs.length - 1;
  if (nextIdx >= thumbs.length) nextIdx = 0;
  thumbs[nextIdx].click();
  syncLightboxToActive();
}

(function() {
  var prev = document.getElementById('lightboxPrev');
  var next = document.getElementById('lightboxNext');
  if (prev) prev.addEventListener('click', function(e) { e.stopPropagation(); lightboxStep(-1); });
  if (next) next.addEventListener('click', function(e) { e.stopPropagation(); lightboxStep(1); });

  var lightboxImage = document.getElementById('lightboxImage');
  if (lightboxImage) {
    // Click/tap toggles 2x zoom at the pointer; mouse or finger pans while zoomed.
    // Uses offset* (layout box) so the scaled box doesn't feed back into the origin.
    var panZoom = function(p) {
      var x = (p.clientX - lightboxImage.offsetLeft) / lightboxImage.offsetWidth * 100;
      var y = (p.clientY - lightboxImage.offsetTop) / lightboxImage.offsetHeight * 100;
      lightboxImage.style.transformOrigin = Math.min(100, Math.max(0, x)) + '% ' + Math.min(100, Math.max(0, y)) + '%';
    };
    lightboxImage.style.transition = 'transform 0.2s ease';
    lightboxImage.addEventListener('click', function(e) {
      e.stopPropagation();
      if (lightboxImage.style.transform) {
        lightboxImage.style.transform = '';
        lightboxImage.style.cursor = 'zoom-in';
        return;
      }
      panZoom(e);
      lightboxImage.style.transform = 'scale(2)';
      lightboxImage.style.cursor = 'zoom-out';
    });
    lightboxImage.addEventListener('mousemove', function(e) {
      if (lightboxImage.style.transform) panZoom(e);
    });
    var sx = 0, sy = 0, ddx = 0, ddy = 0, sw = false;
    lightboxImage.addEventListener('touchstart', function(e) {
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY; ddx = 0; ddy = 0; sw = false;
    }, { passive: true });
    lightboxImage.addEventListener('touchmove', function(e) {
      var t = e.touches[0]; ddx = t.clientX - sx; ddy = t.clientY - sy;
      if (lightboxImage.style.transform) { panZoom(t); return; }
      if (Math.abs(ddx) > 10 && Math.abs(ddx) > Math.abs(ddy)) sw = true;
    }, { passive: true });
    lightboxImage.addEventListener('touchend', function(e) {
      if (!sw || Math.abs(ddx) < 40) return;
      e.stopPropagation();
      lightboxStep(ddx < 0 ? 1 : -1);
    });
  }
})();

document.addEventListener('keydown', function(e) {
  var lightbox = document.getElementById('imageLightbox');
  if (lightbox && lightbox.classList.contains('active')) {
    if (e.key === 'ArrowLeft') { lightboxStep(-1); return; }
    if (e.key === 'ArrowRight') { lightboxStep(1); return; }
  }
  if (e.key === 'Escape') {
    closeLightbox();
    closeCartToast();
  }
});

function updateVariantFromOptions() {
  var optionSelectors = document.querySelectorAll('.option-selector');
  var masterSelect = document.getElementById('variantSelect');
  if (!masterSelect || optionSelectors.length === 0) return;

  var selectedOptions = [];
  optionSelectors.forEach(function(select) {
    selectedOptions.push(select.value);
  });

  var variantsDataEl = document.getElementById('productVariantsData');
  var variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
  var matchingVariant = variants.find(function(variant) {
    return variant.options.every(function(opt, index) { return opt === selectedOptions[index]; });
  });

  if (matchingVariant) {
    masterSelect.value = matchingVariant.id;
    updateVariantDisplay(matchingVariant);
  }
}

function updateVariantDisplay(selectedVariant) {
  if (!selectedVariant) return;

  var fmt = function(cents) {
    return new Intl.NumberFormat(USCT_PDP.locale, {
      style: 'currency',
      currency: USCT_PDP.currency
    }).format(cents / 100);
  };

  document.getElementById('productPrice').textContent = fmt(selectedVariant.price);
  var stickyPrice = document.getElementById('stickyAtcPrice');
  if (stickyPrice) stickyPrice.textContent = fmt(selectedVariant.price);

  var priceRow = document.querySelector('.price-row');
  var oldOriginal = priceRow.querySelector('.original-price');
  var oldSavings = priceRow.querySelector('.savings-badge');
  if (oldOriginal) oldOriginal.remove();
  if (oldSavings) oldSavings.remove();

  if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
    var originalEl = document.createElement('span');
    originalEl.className = 'original-price';
    originalEl.textContent = fmt(selectedVariant.compare_at_price);
    priceRow.appendChild(originalEl);

    var savingsEl = document.createElement('span');
    savingsEl.className = 'savings-badge';
    savingsEl.textContent = 'Save ' + fmt(selectedVariant.compare_at_price - selectedVariant.price);
    priceRow.appendChild(savingsEl);
  }

  if (selectedVariant.featured_image) {
    var baseSrc = selectedVariant.featured_image.src.replace(/\?.*$/, '');
    var newSrc = baseSrc + '?width=1200';
    var _mi2 = document.getElementById('mainImage'); _mi2.removeAttribute('srcset'); _mi2.src = newSrc;

    var baseFile = baseSrc.replace(/.*\//, '').replace(/_\d+x\d+\./, '.');
    var thumbs = document.querySelectorAll('.thumbnail');
    thumbs.forEach(function(t) {
      t.classList.remove('active');
      var thumbImg = t.querySelector('img');
      if (thumbImg) {
        var thumbFile = thumbImg.src.replace(/\?.*$/, '').replace(/.*\//, '').replace(/_\d+x\d+\./, '.');
        if (thumbFile === baseFile) t.classList.add('active');
      }
    });
  }

  var stockBadge = document.getElementById('stockBadge');
  if (stockBadge) {
    stockBadge.style.display = selectedVariant.available ? '' : 'none';
  }

  var quoteLink = document.getElementById('pdpQuoteEmail');
  if (quoteLink) {
    var quoteBody = USCT_PDP.quoteBody + '\n\n' + USCT_PDP.title + '\n' + selectedVariant.title + '\nSKU: ' + (selectedVariant.sku || '') + '\n' + USCT_PDP.url + '?variant=' + selectedVariant.id;
    quoteLink.href = 'mailto:info@uscleaningtools.com?subject=' + encodeURIComponent(USCT_PDP.quoteSubject + ' ' + USCT_PDP.title) + '&body=' + encodeURIComponent(quoteBody);
  }
  var skuTopElement = document.getElementById('productSkuTop');
  var skuValue = selectedVariant.sku || 'N/A';
  if (skuTopElement) skuTopElement.textContent = skuValue;

  var addToCartBtn = document.getElementById('addToCartBtn');

  if (!selectedVariant.available) {
    if (addToCartBtn) {
      addToCartBtn.disabled = true;
      addToCartBtn.innerHTML = '<span>Sold Out</span>';
    }
  } else {
    if (addToCartBtn) {
      addToCartBtn.disabled = false;
      addToCartBtn.innerHTML = '<svg class="btn-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg><span>Add to Cart</span>';
    }
  }
}

function addToCart() {
  var btn = document.getElementById('addToCartBtn');
  var variantId = document.getElementById('variantSelect') ? document.getElementById('variantSelect').value : String(USCT_PDP.variantId);
  var quantity = parseInt(document.getElementById('quantity').value) || 1;

  var originalText = btn.innerHTML;
  btn.disabled = true;
  btn.innerHTML = '<svg class="btn-icon" style="animation: spin 1s linear infinite;" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"><circle cx="12" cy="12" r="10" stroke-width="2" stroke-dasharray="31.4" stroke-dashoffset="10"/></svg><span>Adding...</span>';
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
  })
  .then(function(res) { return res.json().then(function(data) { return { ok: res.ok, data: data }; }); })
  .then(function(r) {
    btn.innerHTML = originalText;
    btn.disabled = false;
    if (!r.ok) { showError(r.data.description || r.data.message || 'Could not add to cart. Please try again.'); return; }
    updateCartCount();
    showCartToast();
  })
  .catch(function(err) {
    console.error(err);
    btn.innerHTML = originalText;
    btn.disabled = false;
    showError('Error adding to cart. Please try again.');
  });
}

var cartToastTimer;
function showCartToast() {
  var toast = document.getElementById('cartToast');
  toast.classList.add('show');
  clearTimeout(cartToastTimer);
  cartToastTimer = setTimeout(closeCartToast, 6000);
}

function closeCartToast() {
  var toast = document.getElementById('cartToast');
  toast.classList.remove('show');
}

function updateCartCount() {
  fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {

      var el = document.querySelector('[data-header-cart-count]');
      if (!el) return;
      el.setAttribute('data-header-cart-count', cart.item_count > 0 ? cart.item_count : '');
      el.classList.toggle('visible', cart.item_count > 0);
    })
    .catch(function() {});
}

function subscribeBackInStock() {
  var emailInput = document.getElementById('bistockEmail');
  var email = emailInput ? emailInput.value.trim() : '';

  if (!email || !email.includes('@')) {
    showError('Please enter a valid email address.');
    return;
  }

  var btn = emailInput.nextElementSibling;
  var originalText = btn.textContent;
  btn.textContent = 'Submitting...';
  btn.disabled = true;

  fetch('/contact', {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: 'form_type=customer&utf8=✓&contact[email]=' + encodeURIComponent(email) + '&contact[body]=' + encodeURIComponent('Back in stock request for: ' + USCT_PDP.title + ' (' + USCT_PDP.handle + ')')
  })
  .then(function() {
    btn.textContent = 'Subscribed!';
    btn.style.background = '#10B981';
    emailInput.value = '';
    emailInput.placeholder = 'We\'ll notify you!';
    emailInput.disabled = true;
  })
  .catch(function() {
    btn.textContent = originalText;
    btn.disabled = false;
    showError('Could not subscribe. Please try again.');
  });
}

function showError(message) {
  var errorDiv = document.createElement('div');
  errorDiv.style.cssText = 'position:fixed;bottom:30px;right:30px;background:#EF4444;color:white;padding:16px 24px;border-radius:10px;box-shadow:0 10px 25px rgba(0,0,0,0.2);font-weight:600;font-size:14px;z-index:10000;';
  errorDiv.textContent = message;
  document.body.appendChild(errorDiv);
  setTimeout(function() { errorDiv.remove(); }, 4000);
}

function switchTab(tabName, clickedBtn) {
  document.querySelectorAll('.tab-btn').forEach(function(btn) {
    btn.classList.remove('active');
    btn.setAttribute('aria-selected', 'false');
  });
  document.querySelectorAll('.tab-content').forEach(function(content) {
    content.classList.remove('active');
  });

  clickedBtn.classList.add('active');
  clickedBtn.setAttribute('aria-selected', 'true');
  document.getElementById(tabName).classList.add('active');
}

function shareProduct(event) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }

  var productTitle = USCT_PDP.title;
  var productUrl = window.location.href;

  if (navigator.share) {
    navigator.share({
      title: productTitle,
      url: productUrl
    }).then(function() {
      showShareSuccess();
    }).catch(function(error) {
      if (error.name !== 'AbortError') {
        copyToClipboard(productUrl);
      }
    });
  } else {
    copyToClipboard(productUrl);
  }
}

function copyToClipboard(text) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(function() {
      showShareSuccess();
    }).catch(function() {
      fallbackCopy(text);
    });
  } else {
    fallbackCopy(text);
  }
}

function fallbackCopy(text) {
  var textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.style.position = 'fixed';
  textArea.style.left = '-999999px';
  document.body.appendChild(textArea);
  textArea.select();

  try {
    document.execCommand('copy');
    showShareSuccess();
  } catch (err) {
    alert('Unable to copy link. Please copy manually: ' + text);
  }

  document.body.removeChild(textArea);
}

function showShareSuccess() {
  var successMsg = document.getElementById('shareSuccess');
  successMsg.classList.add('show');
  setTimeout(function() {
    successMsg.classList.remove('show');
  }, 3000);
}

(function() {
  var mainImage = document.querySelector('.main-image');
  if (!mainImage) return;

  var startX = 0, startY = 0, dx = 0, dy = 0, swiping = false;

  mainImage.addEventListener('touchstart', function(e) {
    var t = e.touches[0];
    startX = t.clientX;
    startY = t.clientY;
    dx = 0; dy = 0;
    swiping = false;
  }, { passive: true });

  mainImage.addEventListener('touchmove', function(e) {
    var t = e.touches[0];
    dx = t.clientX - startX;
    dy = t.clientY - startY;
    if (Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) swiping = true;
  }, { passive: true });

  mainImage.addEventListener('touchend', function(e) {
    if (!swiping || Math.abs(dx) < 40) return;
    e.preventDefault();
    var thumbs = document.querySelectorAll('.thumbnail');
    if (thumbs.length < 2) return;
    var idx = getActiveThumbIndex();
    if (dx < 0 && idx < thumbs.length - 1) thumbs[idx + 1].click();
    if (dx > 0 && idx > 0) thumbs[idx - 1].click();
    var activeThumb = document.querySelector('.thumbnail.active');
    if (activeThumb && activeThumb.scrollIntoView) {
      activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
    }
  });
})();


(function() {
  var atcBtn = document.getElementById('addToCartBtn');
  var bar = document.getElementById('stickyAtc');
  if (!atcBtn || !bar || !('IntersectionObserver' in window)) return;
  new IntersectionObserver(function(entries) {
    var e = entries[0];
    if (!e.isIntersecting && e.boundingClientRect.top < 0) bar.classList.add('visible');
    else bar.classList.remove('visible');
  }).observe(atcBtn);
})();


(function(){
  var mq = window.matchMedia('(max-width: 768px)');
  var root = document.querySelector('.enhanced-product-page');
  var list = root && root.querySelector('.tab-buttons');
  if (!list) return;
  function sync(){
    var accordion = mq.matches;
    list.setAttribute('role', accordion ? 'presentation' : 'tablist');
    root.querySelectorAll('.tab-btn').forEach(function(btn){
      var open = btn.classList.contains('active');
      if (accordion) {
        btn.setAttribute('role', 'button');
        btn.setAttribute('aria-expanded', open);
        btn.removeAttribute('aria-selected');
      } else {
        btn.setAttribute('role', 'tab');
        btn.setAttribute('aria-selected', open);
        btn.removeAttribute('aria-expanded');
      }
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) panel.setAttribute('role', accordion ? 'region' : 'tabpanel');
    });
  }
  sync();
  mq.addEventListener('change', sync);
  list.addEventListener('click', function(){ setTimeout(sync, 0); });
})();

